<template>
	<div class="container-center">
		<!-- 公共头部 -->
		<home-header></home-header>
		<!-- banner -->
		<div class="banner-info"></div>
		<!-- 教学中心 -->
		<div class="center-wrapper">
			<div class="menu">
				<mt-navbar v-model="selected">
					<mt-tab-item id="1">直营中心</mt-tab-item>
					<mt-tab-item id="2">授权合作方</mt-tab-item>
				</mt-navbar>
				<mt-tab-container v-model="selected">
					<mt-tab-container-item id="1">
					</mt-tab-container-item>
					<mt-tab-container-item id="2">
						<table class="table-wrapper" style="border-collapse:separate; border-spacing:0px 40px;">
							<tr class="par">
								<th>学畅国际教育</th>
								<td><img src="../assets/images/par-xuechang.png"></td>
							</tr>
							<tr>
								<th class="par">BOSS商学院</th>
								<td><img src="../assets/images/par-boss.png"></td>
							</tr>
							<tr>
								<th>德瑞姆应用心理学院 </th>
								<td><img src="../assets/images/par-derui.png" ></td>
							</tr>
							<tr>
								<th>高景亚太 </th>
								<td><img src="../assets/images/par-gjyt.png" ></td>
							</tr>
							<tr>
								<th>启文教育</th>
								<td><img src="../assets/images/par-qinwen.png" ></td>
							</tr>
							<tr>
								<th>北京互联商苑</th>
								<td><img src="../assets/images/par-hulian.jpg"></td>
							</tr>

							<tr>
								<th>商帅商学院 </th>
								<td><img src="../assets/images/par-shangshuai.png"></td>
							</tr>
							<!--<tr>
								<th>杭州东方财智</th>
								<td><img src="../assets/images/par-dongfang.png" class="t7"></td>
							</tr>-->
							<tr>
								<th>中国社科教育培训中心</th>
								<td><img src="../assets/images/par-sheke.png"></td>
							</tr>
							<tr>
								<th>江苏子信</th>
								<td><img src="../assets/images/par-zixin.png"></td>
							</tr>
							<tr>
								<th>成都置信弘文商学院</th>
								<td><img src="../assets/images/par-hongwen.png"></td>
							</tr>
							<tr>
								<th>青岛汉元商学</th>
								<td><img src="../assets/images/par-hanyuan.png"></td>
							</tr>
							<tr>
								<th>福州东日教育</th>
								<td><img src="../assets/images/par-dongri.png"></td>
							</tr>
							<tr>
								<th>CIO互联商苑</th>
								<td><img src="../assets/images/cio-logo.jpg"></td>
							</tr>
						</table>
					</mt-tab-container-item>
				</mt-tab-container>
			</div>
		</div>
		<!-- 公共版权 -->
		<home-footer></home-footer>
	</div>
</template>
<script>
	import HomeHeader from "@/components/homeHeader";
	import HomeFooter from "@/components/homeFooter";
	export default {
		name: "NewsDetails",
		components: {
			HomeHeader,
			HomeFooter
		},
		data() {
			return {
				selected: "1"
			};
		},
		methods: {},
		mounted() {}
	};
</script>
<style scoped>
	.center-wrapper {
		width: 95%;
		height: auto;
		margin: 0 auto;
		margin-bottom: 10px;
	}

	.banner-info {
		width: 100%;
		height: 200px;
		background: url('../assets/images/banner002.png');
		background-size: 100% 100%;
	}

	.menu {
		width: 95%;
		margin: 0 auto;
		padding-top: 30px;
		margin-bottom: 50px;
	}
	/*tab切换样式 */

	.mint-navbar {
		width: 100%;
		height: 60px;
	}

	.mint-navbar .mint-tab-item {
		border: 2px solid #E58111;
		width: 348px;
		height: 60px;
		color: #E58111;
	}

	.mint-navbar .mint-tab-item.is-selected {
		background: #E58111;
		font-size: 24px;
		color: #fff;
	}

	>>>.mint-tab-item-label {
		font-size: 26px;
	}

	.table-wrapper {
		width: 100%;
	}

	th {
		width: 30%;
		min-height: 80px;
		text-align: center;
		vertical-align: middle;
		font-size: 30px;
		color: #343434;
	}

	td {
		width: 80%;
		min-height: 80px;
		border-left: 2px solid #E58111;
		font-size: 29px;
		padding-left: 50px;
		vertical-align: middle;
		color: #343434;
		line-height: 45px;
	}

	.par {
		width: 50%;
	}

	td img {
		/*width: 200px;*/
		/*height: 68px;*/
	}

	.t1 {
		width: 75px;
		height: 79px;
	}

	.t2 {
		width: 143px;
		height: 27px;
	}

	.t5 {
		width: 76px;
		height: 90px;
	}

	.t7 {
		width: 95px;
		height: 90px;
	}

	.t8 {
		width: 80px;
		height: 80px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/teacherCenter.vue